import { Button, DialogContainer } from '@adobe/react-spectrum';
import qs from 'query-string';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { ContactPublisherDialog } from '@exchange-frontends/components';

export const MESSAGES = {
  company: {
    empty: 'Enter your company name.',
    maxLength: 'Invalid format: this field accepts a max number of 100 characters.',
  },
  message: {
    empty: 'Enter a message to publisher.',
    maxLength: 'Invalid format: this field accepts a max number of 1000 characters',
  },
  terms: {
    empty: 'Select the checkbox to continue.',
  },
};

const ContactPublisherButton = ({ isPreview }) => {
  const dialogTitle = 'Connect with publisher';
  const dialogContent =
    'Request more information about the solution from this partner. (For support related questions reach out through the "get support" channel for the quickest response, for Exchange related support reach out to our support team';
  const navigate = useNavigate();
  const { id } = useParams();
  const search = useLocation().search;
  const section = qs.parse(search).section;
  const isDialogOpen = section === 'contact-publisher';

  const setIsDialogOpen = (newVal) => {
    if (newVal) {
      navigate({ search: qs.stringify({ section: 'contact-publisher' }) }, { replace: true });
    } else {
      navigate({ search: '' }, { replace: true });
    }
  };

  return (
    <>
      <Button
        onPress={() => setIsDialogOpen(true)}
        data-testid="connect-with-publisher-button"
        data-launchid={`Help and Support : Connect with publisher`}
        isDisabled={isPreview}
      >
        Connect with publisher
      </Button>
      <DialogContainer onDismiss={() => {}}>
        {isDialogOpen && (
          <ContactPublisherDialog
            appId={id}
            title={dialogTitle}
            description={dialogContent}
            close={() => setIsDialogOpen(false)}
          />
        )}
      </DialogContainer>
    </>
  );
};
export default ContactPublisherButton;
